import { CalendarIcon } from 'lucide-react'

// Formats a date as "1/1" (month/day, no year)
// Uses UTC timezone to avoid timezone offset issues with ISO date strings
function getShortLocalizedDateString (dateToLocalize: Date): string {
  return dateToLocalize.toLocaleDateString('en-US', {
    month: 'numeric',
    day: 'numeric',
    timeZone: 'UTC',
  })
}

// Submit by [date] to start [date]
export const SubmitByBadge = ({ submitByDate, coverageStartDate }: { submitByDate: string, coverageStartDate: string }) => {
  if (!submitByDate || !coverageStartDate) return null

  const parsedSubmitByDate = new Date(submitByDate)
  const parsedCoverageStartDate = new Date(coverageStartDate)

  if (isNaN(parsedSubmitByDate.getTime()) || isNaN(parsedCoverageStartDate.getTime())) return null

  const formattedSubmitByDate = getShortLocalizedDateString(parsedSubmitByDate)
  const formattedCoverageStartDate = getShortLocalizedDateString(parsedCoverageStartDate)

  return (
    <div className='inline-flex max-w-full min-w-0 px-2 py-1 items-center gap-2 body-sm bg-gray-50 border border-gray-400 rounded-full'>
      <CalendarIcon size={12} className='shrink-0 text-gray-500' />
      <span className='min-w-0 break-words'>Submit by {formattedSubmitByDate} to start {formattedCoverageStartDate}</span>
    </div>
  )
}
